import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Link } from "react-router-dom";
import { ShowSwal, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';
import { getInvoiceTemplateByInvoiceTemplateIdAsync, deleteInvoiceTemplateAsync } from "./invoiceTemplateSlice";
const itemClass = 'ms-1 ms-lg-0';

export const InvoiceTemplateItem = (props: any) => {
    const { modelRef, invoicetemplateList, onopenModal, IsEdit, IsDelete } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.invoiceTemplate);
    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {

        } else {
            
        }
    };
    const onEditClick = (AccountInvoiceTemplateId: string) => {
        dispatch(getInvoiceTemplateByInvoiceTemplateIdAsync(AccountInvoiceTemplateId))
            .unwrap()
            .then((originalPromiseResult) => {
                modelRef.current.click();
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getExternalUserByExternalUserIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }
    const onDeleteClick = (AccountInvoiceTemplateId: string) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteInvoiceTemplateAsync(AccountInvoiceTemplateId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("External user deleted Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            console.log('onDeleteClick-deleteExternalUserAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }
    const onUnverifiedClick = (AccountEmployeeId: number) => {

    }

    const handleSelectAllChange = (e: any) => {

    };

    return (
        <>

            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        <th className='w-15'>
                            {/* {t('Active / Inactive')} */}
                             {getValueFromResource('Active / Inactive', dispatch,t)}
                            </th>
                        <th className='w-75'>
                            {/* {t('Template Name')} */}
                             {getValueFromResource('Template Name', dispatch,t)}
                            </th>
{/*                         <th className='col'>{t('Account Name')}</th>
                        <th className='col'>{t('Address1')}</th>
                        <th className='col'>{t('Address2')}</th>
                        <th className='col'>{t('City')}</th>
                        <th className='col'>{t('Country')}</th> */}
                        {/* <th className='col'>{t('EMailAddress')}</th> */}
                        
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {invoicetemplateList.length > 0 && invoicetemplateList.map((invoiceTemplateDetail: any, i: any) => (

                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(invoiceTemplateDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {invoiceTemplateDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td>
                                <a id={`${IsEdit ? 'kt_OffCanvas' : ''}`}
                                    className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                    style={{ cursor: 'pointer' }}
                                    onClick={IsEdit ? () => onEditClick(invoiceTemplateDetail.AccountInvoiceTemplateId) : undefined}>
                                    {invoiceTemplateDetail.AccountInvoiceTemplateName}
                                </a>
                            </td>

                            {/* <td><span className="">{invoiceTemplateDetail.AccountName}</span></td>
                            <td><span className="">{invoiceTemplateDetail.Address1}</span></td>
                            <td><span className="">{invoiceTemplateDetail.Address2}</span></td>
                            <td><span className="">{invoiceTemplateDetail.City}</span></td>
                            <td><span className="">{invoiceTemplateDetail.Country}</span></td> */}
                            {/* <td><span className="">{invoiceTemplateDetail.EMailAddress}</span></td> */}

                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                         {getValueFromResource('More', dispatch,t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => onEditClick(invoiceTemplateDetail.AccountInvoiceTemplateId)}
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                             {getValueFromResource('Edit', dispatch,t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>

                                            </>
                                        }

                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(invoiceTemplateDetail.AccountInvoiceTemplateId) }}>
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize" >
                                                            {/* {`${t('Delete')}`} */}
                                                             {getValueFromResource('Delete', dispatch,t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
            {invoicetemplateList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                         {getValueFromResource('No Record Found', dispatch,t)}
                        </p>
                </div>
            }

        </>
    )


}
export default InvoiceTemplateItem